<template>
    <div class="g__c g__c--md4" v-if="result != null">
        <div class="lookup-box">
            <div class="lookup-box__top">
                <h6 class="lookup-box__heading">{{result.propertyName}}</h6>
                <p class="lookup-box__title">{{result.propertyNumber}}</p>
            </div>
            <div class="lookup-box__info">
                <address class="lookup-box__address">
                    <p class="lookup-box__street">{{result.city}}</p>
                </address>
                <div class="lookup-box__row">
                    <p class="lookup-box__term">{{result.contactName}}</p>
                    <p class="lookup-box__term">{{result.jobTitle}}</p>
                </div>
                <div class="lookup-box__row">
                    <p class="lookup-box__term" v-if="!!result.contactPhone1">                    
                        <span class="lookup-box__description" v-if="!!result.contact1Label">{{result.contact1Label}}</span>
                        <a class="lookup-box__phone" :href="'tel:'+ result.contactPhone1">{{result.contactPhone1}}</a>
                    </p>
                    <p class="lookup-box__term" v-if="!!result.contactPhone2">                    
                        <span class="lookup-box__description" v-if="!!result.contact2Label">{{result.contact2Label}}</span>
                        <a class="lookup-box__phone" :href="'tel:'+ result.contactPhone2">{{result.contactPhone2}}</a>
                    </p> 
                    <p class="lookup-box__term" v-if="!!result.contactPhone3">                        
                        <span class="lookup-box__description" v-if="!!result.contact3Label">{{result.contact3Label}}</span>
                        <a class="lookup-box__phone" :href="'tel:'+result.contactPhone3">{{result.contactPhone3}}</a>
                    </p>
                </div>
                <a class="lookup-box__email" :href="result.contactFormLink" v-if="!!result.contactFormLink">Contact</a>                
            </div>
        </div>
    </div>
</template>
  
<script>
export default {
    props: {
        result: Object,
    },
};
</script>